import { useState } from 'react';
import { floorPlans } from '../../../mocks/floorPlans';

export default function FloorPlans() {
  const [activeTab, setActiveTab] = useState<'1dorm' | '2dorms' | '3dorms'>('2dorms');

  const tabs = [
    { id: '1dorm' as const, label: '1 Dormitório' },
    { id: '2dorms' as const, label: '2 Dormitórios' },
    { id: '3dorms' as const, label: '3 Dormitórios' },
  ];

  const activePlan = floorPlans[activeTab];

  return (
    <section id="plantas" className="bg-gray-50 py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Title */}
        <div className="mb-12">
          <h2 className="font-serif font-bold text-5xl lg:text-6xl text-black">
            Plantas e Tipologias
          </h2>
        </div>

        {/* Tabs */}
        <div className="flex space-x-12 mb-12 border-b border-gray-300">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`pb-4 font-medium text-lg transition-all whitespace-nowrap cursor-pointer ${
                activeTab === tab.id
                  ? 'text-black border-b-4 border-primary'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Floor Plan Image */}
          <div className="bg-white rounded-3xl p-10 shadow-sm">
            <div className="aspect-square flex items-center justify-center">
              <img
                src={`https://public.readdy.ai/ai/img_res/d68bd9e7fc2c15fee832e67d7c993a26.jpg$%7BactiveTab%7D%20layout%20with%20living%20room%20kitchen%20bedroom%20bathroom%20clean%20simple%20design%20professional%20architectural%20drawing%20white%20background%20high%20quality&width=600&height=600&seq=atmos-plan-${activeTab}&orientation=squarish`}
                alt={activePlan.title}
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          {/* Right - Specifications */}
          <div>
            <h3 className="font-serif font-bold text-4xl text-black mb-8">
              {activePlan.title}
            </h3>

            <div className="space-y-6">
              {activePlan.specs.map((spec, index) => (
                <div key={index} className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${spec.icon} text-primary text-xl`}></i>
                  </div>
                  <div>
                    <p className="text-gray-600 text-sm">{spec.label}</p>
                    <p className="text-black font-semibold text-lg">{spec.value}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="https://wa.me/5541988674555?text=Olá! Quero valores e disponibilidade do ATMOS."
              target="_blank"
              rel="noopener noreferrer"
              className="mt-10 inline-flex items-center space-x-2 bg-[#25D366] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#20BA5A] transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Quero Valores e Disponibilidade</span>
              <i className="ri-whatsapp-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
